import { AlpineComponent } from 'alpinejs';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import { PlayerEvents } from '../plugins/video-player/Player';

type GalleryData = {}

export default ():AlpineComponent<GalleryData> => ({
  init() {
    const swiperEl = this.$root.querySelector<HTMLElement>('.swiper');

    if (!swiperEl) {
      return;
    }

    new Swiper(swiperEl, {
      speed: 500,
      threshold: 10,
      slidesPerView: 1,
      watchOverflow: true,
      followFinger: true,
      updateOnWindowResize: true,
      modules: [Navigation, Pagination],
      navigation: {
        prevEl: this.$root.querySelector<HTMLElement>('.ce-gallery-btn--prev'),
        nextEl: this.$root.querySelector<HTMLElement>('.ce-gallery-btn--next'),
      },
      pagination: {
        el: '.ce-gallery-pagination',
        clickable: true,
      },
      on: {
        slideChange: (swiper) => {
          const video: HTMLVideoElement | null = swiper.slides[swiper.previousIndex].querySelector<HTMLVideoElement>('.ce-gallery-item');
          video?.closest('[x-video-player]')?.dispatchEvent(PlayerEvents.stop);
        },
        slidesLengthChange: (swiper) => {
          this.$lazyLoad.update();

          if (this.$cookies) {
            this.$cookies.run(swiper.el);
          }
        },
      }
    });
  },
});
